import React from "react";

const PlayerInfo = ({level, faction, race, classPicked}) => {
  return <div />;
};

export default PlayerInfo;
